import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums";


   const GetYdMpOrder=(data:any)=>{
    let url = ApiURL.Query.GetOrder+"?OriginCode="+data.OriginCode;
    if (data.ReturnShipmentNumber) {
      url += "&ReturnShipmentNumber="+encodeURIComponent(data.ReturnShipmentNumber);
    } else if (data.MarketplaceOrderId) {
      url += "&MarketplaceOrderId="+encodeURIComponent(data.MarketplaceOrderId);
    }
    return request({
      url: url,
      method: RequestType.GET,
      data:data
    });
   };
   const ReturnYdMpOrder=(data:any):Promise<any>=>request({
    url: ApiURL.Query.ReturnOrder,
    method: RequestType.POST,
    data:data
   });
   const GetMpOrigins=(data:any):Promise<any>=>request({
      url: ApiURL.Query.GetMpOrigins+"?IsConsignee="+data,
      method: RequestType.GET,
      data:data
     });

   const GetPackageDetail = (data: any): Promise<any> => {
      let url = ApiURL.Query.GetPackageDetail + "?OriginCode=" + data.OriginCode;
      if (data.TrackingID) url += "&TrackingID=" + data.TrackingID;
      
      return request({
         url: url,
         method: RequestType.GET,
      });
   };
 
   
   const GetYdMpOrderQuery = {
       GetYdMpOrder,
       ReturnYdMpOrder,
       GetMpOrigins,
       GetPackageDetail
    };
    export default GetYdMpOrderQuery;